import { render, staticRenderFns } from "./sequence-review-info.vue?vue&type=template&id=6a3810cc&scoped=true&v-if=associate&"
import script from "./sequence-review-info.vue?vue&type=script&lang=js&"
export * from "./sequence-review-info.vue?vue&type=script&lang=js&"
import style0 from "./sequence-review-info.vue?vue&type=style&index=0&id=6a3810cc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a3810cc",
  null
  
)

export default component.exports